import {Navigate, Outlet} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes.tsx'
import {useAuthStore} from '@/features/auth/store/store.ts'

export const PublicRoute = () => {
    const accessToken = useAuthStore(state => state.accessToken)

    return accessToken ? <Navigate to={routes.CONVERSATION_HISTORY.path} /> : <Outlet />
}
